module.exports = __webpack_public_path__ + "static/media/barrel5.ec9f772c.jpg";